export const FETCH_SNAPSHOT_REQUEST = 'FETCH_SNAPSHOT_REQUEST';
export const FETCH_SNAPSHOT_SUCCESS = 'FETCH_SNAPSHOT_SUCCESS';
export const FETCH_SNAPSHOT_FAILURE = 'FETCH_SNAPSHOT_FAILURE';

export const FETCH_ENGAGEMENT_DETAILS_REQUEST = 'FETCH_ENGAGEMENT_DETAILS_REQUEST';
export const FETCH_ENGAGEMENT_DETAILS_SUCCESS = 'FETCH_ENGAGEMENT_DETAILS_SUCCESS';
export const FETCH_ENGAGEMENT_DETAILS_FAILURE = 'FETCH_ENGAGEMENT_DETAILS_FAILURE';
